<template>
  <v-container class="ma-0 pa-0">
    <!-- Used to display main buttons in ebook start -->
    <v-card flat>
      <v-list class="ml-4">
        <v-list-item
          v-for="(item, index) in ebooks"
          :key="`ebook-${index}`"
          @click="$router.push({ name: 'EbookStart', params: { id: item.id } })"
        >
          <v-list-item-icon>
            <v-icon>$sl-ebook</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>
              {{ getEbookTitle(item) }}
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-icon class="ml-auto">
            <v-icon size="10">$sl-arrow-right</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
import API from '@/services/api.js'
import { mapGetters } from 'vuex'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import { CompanyRoles } from '@/components/mixins'

const SugarDate = require('sugar/date')

export default {
  name: 'EbookList',

  mixins: [CompanyRoles],

  props: {
    ebooks: Array
  },

  data: () => ({
    showEbookList: false,
    bookId: -1,
    options: []
  }),

  mounted() {
    this.$scrollToTop()
  },

  computed: {
    ...mapGetters('currentuser', [
      'currentUser',
      'isApprentice',
      'isInstructor',
      'isCompanyUser'
    ]),
    ...mapGetters('basic', [
      'apprenticeDraftStateId',
      'companyDraftStateId',
      'basicProfessions',
      'confirmedByCompany'
    ])
  },

  filters: {
    dateFormat(date) {
      if (date && date !== '') {
        return SugarDate.Date(date).format('%Y-%m-%d %H:%M')
      }

      return ''
    }
  },

  methods: {
    getEbookTitle(item) {
      let my = ''

      if (this.isInstructor(0) === true) {
        my = this.$t('labels.my') + ' '
      }

      let title = my + this.$t('labels.my-book') + ' - ' + item?.profession?.name

      if (this.ebooks.length > 1) {
        title = item?.profession?.name + ' - ' + my + this.$t('ebook.button-label') + ' ' + this.shortDateFormat(item.createdAt)
      }

      return title
    },

    shortDateFormat(date) {
      if (date && date !== '') {
        return SugarDate.Date(date).format('%Y-%m-%d')
      }

      return ''
    },

    professionName(id) {
      if (!id) {
        return ''
      }

      const p = find(this.basicProfessions, ['id', id])

      return p ? `${p.name}` : ''
    }
  }
}
</script>